module.exports = __webpack_public_path__ + "img/dessert-1.7e0e0345.jpg";